import { render, staticRenderFns } from "./insuranceUser.vue?vue&type=template&id=6aa2e3ed&scoped=true"
import script from "./insuranceUser.vue?vue&type=script&lang=js"
export * from "./insuranceUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa2e3ed",
  null
  
)

export default component.exports